import { endpoints } from "@cayo/shared/services/endpoints.service";
import { urlUtils } from "@cayo/shared/utils/url";
import apiPaths from "../utils/api-path";

const databaseSettings = urlUtils.buildRelativePath(
  endpoints.PUBLIC_URL,
  apiPaths.historyDatabaseSettings
);

const uiSettings = urlUtils.buildRelativePath(endpoints.PUBLIC_URL, apiPaths.uiSettings);

const networkSettings = urlUtils.buildRelativePath(endpoints.PUBLIC_URL, apiPaths.networkSettings);

const productConfigSummary = urlUtils.buildRelativePath(
  endpoints.PUBLIC_URL,
  apiPaths.productConfigSummary
);

export const settingsEndpoints = {
  databaseSettings,
  uiSettings,
  networkSettings,
  productConfigSummary,
};
